// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"c3ff248d","57":"951dc402","84":"7f52840f","284":"9d753e92","370":"f9bfc691","453":"fa694569","750":"81d44db4","834":"2d82da10","850":"9f275f11"}[chunkId] + ".chunk.js";
};